import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';

/**
 * After Emergent's Google OAuth redirects back with #session_id=xxx, this
 * page exchanges that session_id for our own session_token and redirects
 * the user to the generate page. Awards 40 daily credits on first sign-in.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { loginWithGoogleSession } = useAuth();
  const [status, setStatus] = useState('Signing you in…');

  useEffect(() => {
    const run = async () => {
      const hash = window.location.hash || '';
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) {
        setStatus('No session ID returned by Google.');
        setTimeout(() => navigate('/'), 1500);
        return;
      }
      const sessionId = match[1];
      try {
        const { isNewUser } = await loginWithGoogleSession(sessionId);
        // Strip the fragment
        window.history.replaceState({}, document.title, window.location.pathname);
        if (isNewUser) {
          toast.success('Welcome! 40 daily credits added to your account.');
        } else {
          toast.success('Welcome back!');
        }
        // Honor any pre-OAuth redirect target (e.g. gift claim page).
        // Without this, /claim-gift?token=XXX gets dropped during OAuth round-trip.
        let redirectTo = '/';
        try {
          const stashed = localStorage.getItem('post_login_redirect');
          if (stashed && stashed.startsWith('/')) {
            redirectTo = stashed;
          }
          localStorage.removeItem('post_login_redirect');
        } catch (_) {}
        navigate(redirectTo);
      } catch (err) {
        const detail = err?.response?.data?.detail || 'Google sign-in failed';
        setStatus(detail);
        toast.error(detail);
        setTimeout(() => navigate('/'), 3000);
      }
    };
    run();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen bg-[#0F1419] text-white flex items-center justify-center">
      <div className="text-center space-y-4">
        <div className="w-12 h-12 border-4 border-[#FFB238] border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="text-lg">{status}</p>
      </div>
    </div>
  );
}
